import { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NextRoundArrow from 'components/Arrows/NextRoundArrow';
import PrevRoundArrow from 'components/Arrows/PrevRoundArrow';
import * as S from './ArticlesCarouselStyles';
import type { JSX } from 'react';
import useBreakpoint from 'hooks/useBreakpoint';

export interface CarouselProps {
  articles: JSX.Element[];
  className?: string;
  isFullWidth?: boolean;
}

const ArticlesCarousel = ({ articles, className, isFullWidth = false }: CarouselProps) => {
  const isMobile = useBreakpoint('mmMax');
  const [currentSlide, setCurrentSlide] = useState(0);

  const slidesToShow = isFullWidth ? 4.3 : 3.3;
  const slidesToScroll = isFullWidth ? 4 : 3;
  const totalSlides = articles.length - slidesToShow;
  const isAtEnd = currentSlide >= totalSlides - 0.2;

  const settings = {
    className: '',
    infinite: false,
    nextArrow: <NextRoundArrow />,
    prevArrow: <PrevRoundArrow showFade={isAtEnd} />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: isFullWidth ? 3 : 2,
          slidesToShow: isFullWidth ? 3.7 : 2.7,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: isFullWidth ? 2.3 : 1.7,
        },
      },
      {
        breakpoint: 512,
        settings: {
          arrows: false,
          slidesToScroll: 1,
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 390,
        settings: {
          arrows: false,
          slidesToScroll: 1,
          slidesToShow: 1.2,
        },
      },
    ],
    slidesToScroll,
    slidesToShow,
    speed: 500,
    afterChange: (index: number) => setCurrentSlide(index),
  };

  const articlesPerRow = isFullWidth ? 4 : 3;
  const isSlider = articles.length > articlesPerRow || isMobile;
  if (!isSlider) {
    return <S.Wrapper className={`${className} no-slider`}>{articles}</S.Wrapper>;
  }

  return (
    <S.Wrapper className={className}>
      <Slider {...settings}>{articles}</Slider>
    </S.Wrapper>
  );
};

export default ArticlesCarousel;
